<template>
  <div>
    <Product
      :product="product"
      :edit-mode="!isCreate"
      @update-components="onAddComponent"
      @remove-component="onRemoveComponent"
      @update-qty="onUpdateQty"
    />
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline red white--text"
          primary-title
        >
          {{ $t('Warning') }}
        </v-card-title>
        <v-card-text>
          <span>{{ $t('This product is used with the following bundle(s). Remove or replace the component or delete bundle first, before deleting this product') }}</span>

          <v-divider class="my-4"/>

          <router-link
            v-for="product in bundledIn"
            :to="{ name: 'single-product',
                   params: { id: product.id }
            }"
            :key="product.id"
          >
            {{ product.name }}
          </router-link>

        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            {{ $t('OK') }}
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Product from '../components/ProductSingle'

export default {
  name: 'SingleProduct',

  components: {
    Product
  },

  async beforeRouteLeave (to, from, next) {
    if (this.product && this.product.isDirty()) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.product.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Product',
      actions: [
        {
          text: '',
          event: 'save',
          disabled: true
        },
        {
          text: 'Save and close',
          event: 'saveAndClose',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      product: this.$http.make('product'),
      bundledIn: [],
      dialog: false
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      return {
        disabled: !this.product || this.product.inProgress || this.product.errors.length,
        loading: this.product && this.product.inProgress
      }
    },

    saveAndCloseActionStates () {
      return this.saveActionStates
    },

    deleteActionStates () {
      return {
        disabled: !this.product || this.product.inProgress,
        hidden: this.isCreate
      }
    }
  },

  async mounted () {
    this.$radio.$emit('action-panel-actions-update', { event: 'save', action: { text: this.isCreate ? 'Create' : 'Save' } })

    await this.loadProduct()

    this.product.reset()
    this.product.initialized = true

    if (this.isCreate) {
      this.$radio.$emit('action-panel-title', 'New Product')
    } else {
      this.$radio.$emit('action-panel-title', this.product.name)
    }

    if (!(this.product.associated_with_bundles || []).length) {
      return
    }

    this.bundledIn = await this.$http.make('product')
      .where('id', 'like', this.product.associated_with_bundles.join(','))
      .get()
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'products' })
    },

    async onActionSave () {
      try {
        if (!this.isCreate) {
          this.product.without(['variants'])
        }

        if (!this.product.properties) {
          this.product.properties = []
        }

        await this.product.save()
        this.$toast.success(this.$t('Product saved'))

        if (this.isCreate) {
          this.$router.replace({
            name: 'single-product',
            params: { id: this.product.id }
          })
          this.$radio.$emit('action-panel-title', this.product.name)
        }

        return true
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
        return false
      }
    },

    async onActionSaveAndClose () {
      let success = await this.onActionSave()

      if (success) {
        this.$router.push({ name: 'products' })
      }
    },

    async onActionDelete () {
      if ((this.product.associated_with_bundles || []).length) {
        this.dialog = true
        return
      }

      if (!await this.$root.$confirm(this.$t('Danger Zone'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }

      await this.product.delete()
      this.goBack()
    },

    async loadProduct () {
      try {
        this.product = (this.isCreate)
          ? this.$http.make('product')
          : await this.$http.product.find(this.$route.params.id)
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }
    },

    onRemoveComponent (key) {
      let found = this.product.components.findIndex(component => component.key === key)
      if (found > -1) {
        this.product.components.splice(found, 1)
      }
    },

    onAddComponent (component) {
      this.product.components.push(component)
      this.product.components = [...this.product.components]
    },

    onUpdateQty (prop) {
      const found = this.product.components.find(component => component.key === prop.key)
      if (found) {
        found.quantity = prop.qt
      }
    }
  }
}
</script>
